export const DEFAULT_CURRENCY_CODE = 'USD';

const DEFAULT_LOCALE = 'en-US';

export const formatCurrency = (
  value: number,
  currencyCode: string = DEFAULT_CURRENCY_CODE,
  locale: string = DEFAULT_LOCALE
): string => {
  try {
    return value.toLocaleString(locale, { style: 'currency', currency: currencyCode, minimumFractionDigits: 2 });
  } catch {
    return `${value.toFixed(2)} ${currencyCode}`.trim();
  }
};
